const React = require('react')
const { useState, useEffect } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { Table } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { useResponsive, BREAKPOINTS } = require('@hooks')
const { LoadingSpinner } = require('@components')
const { TableHeader } = require('@components/table')
const { NETWORK_CONFIG } = require('@configs')

require('@styles/pages/address/transactions.address.css')

const AssetMultichain = props => {
    const { loading, data } = props
    const history = useHistory()
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const [items, setItems] = useState([])
    const [totalItems, setTotalItems] = useState()
    const isMobile = useResponsive(BREAKPOINTS.extraLarge)

    useEffect(() => {
        if (!data) return

        const tokenList = Object.entries(data.information.multichainBalance).flatMap(([network, item]) =>
            item.tokens.map(token => ({ ...token, network }))
        )

        setItems(tokenList)
        setTotalItems(tokenList.length)
    }, [data])

    return (
        <div className='box table-section' style={{ padding: '0px' }}>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {totalItems > 0 && (
                        <TableHeader title={<>Showing {totalItems.toLocaleString()} tokens</>} usePagination={false} />
                    )}
                    <Table
                        responsive
                        style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}
                    >
                        <thead>
                            <tr>
                                <th>Chain</th>
                                <th>Token</th>
                                <th>Contract</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalItems === 0 ? (
                                <tr>
                                    <td colSpan='4' style={{ textAlign: 'center', padding: '40px 0', height: '400px' }}>
                                        <div
                                            style={{
                                                width: '72px',
                                                height: '72px',
                                                backgroundColor: 'rgba(255, 193, 7, 0.15)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: '0 auto 12px'
                                            }}
                                        >
                                            <i
                                                className='fas fa-inbox'
                                                style={{
                                                    fontSize: '24px',
                                                    color: 'var(--grey-color)'
                                                }}
                                            />
                                        </div>
                                        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                            There are no matching entries
                                        </div>
                                        <div style={{ color: 'var(--grey-color)', marginTop: '4px' }}>
                                            Please try again later
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {items.map(token => {
                                        return (
                                            <tr key={token.tokenAddress}>
                                                <td>{NETWORK_CONFIG[token.network].shortName.toUpperCase()}</td>
                                                <td>
                                                    <span
                                                        className={`${network.name}-text-color cursor-pointer`}
                                                        onClick={() =>
                                                            history.push(
                                                                `/${NETWORK_CONFIG[token.network].shortName}/token/${
                                                                    token.tokenAddress
                                                                }?a=${address}`
                                                            )
                                                        }
                                                    >
                                                        {token.tokenName}
                                                    </span>
                                                    &nbsp;
                                                    <span style={{ color: 'var(--grey-color)' }}>
                                                        ({token.tokenSymbol})
                                                    </span>
                                                </td>
                                                <td>
                                                    <i
                                                        className='fas fa-file-alt'
                                                        style={{
                                                            fontSize: '14px',
                                                            color: 'var(--grey-color)'
                                                        }}
                                                    />
                                                    &nbsp;
                                                    <span
                                                        className={`${network.name}-text-color cursor-pointer`}
                                                        onClick={() =>
                                                            history.push(
                                                                `/${NETWORK_CONFIG[token.network].shortName}/token/${
                                                                    token.tokenAddress
                                                                }`
                                                            )
                                                        }
                                                    >
                                                        {token.tokenAddress}
                                                    </span>
                                                </td>
                                                <td>
                                                    {(token.balance / 10 ** token.tokenDecimals).toLocaleString(
                                                        undefined,
                                                        {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: token.tokenDecimals
                                                        }
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </>
                            )}
                        </tbody>
                    </Table>
                </>
            )}
        </div>
    )
}

module.exports = { AssetMultichain }
